const ANALYTICS_EVENTS = {
  REGISTRO_USUARIO_COMPLETADO: 'registro_usuario_completado',
  REGISTRO_EMPRESA_EXITOSO: 'registro_empresa_exitoso',
  INICIO_SESION_EXITOSO: 'inicio_sesion_exitoso',
  CIERRE_SESION_EXITOSO: 'cierre_sesion_exitoso',
  CAJA_ABIERTA_EXITOSO: 'caja_abierta_exitoso',
  MOVIMIENTO_CAJA_REGISTRADO: 'movimiento_caja_registrado',
  CAJA_CERRADA_EXITOSO: 'caja_cerrada_exitoso',
  FLUJO_VENTA_ABANDONADO: 'flujo_venta_abandonado',
  COMPROBANTE_ESTADO_ACTUALIZADO: 'comprobante_estado_actualizado',
  AYUDA_CONSULTADA: 'ayuda_consultada',
  BORRADOR_ACCION_REALIZADA: 'borrador_accion_realizada',
  VENTA_COMPLETADA: 'venta_completada',
  PRIMERA_VENTA_COMPLETADA: 'primera_venta_completada',
  PRODUCTO_CREADO_EXITOSO: 'producto_creado_exitoso',
  CLIENTE_CREADO_EXITOSO: 'cliente_creado_exitoso',
  IMPORTACION_COMPLETADA: 'importacion_completada',
} as const

export type AnalyticsEventName = (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS]

export { ANALYTICS_EVENTS as EVENTOS_ANALITICA }

export type EntornoAnalitica = 'demo' | 'produccion'

export type OrigenVenta = 'emision' | 'pos'

export type MotivoCierreSesionAnalitica = 'manual' | 'expiracion_sesion' | 'renovacion_fallida' | 'otro'

export type MotivoAbandonoVenta = 'cancelacion_usuario' | 'salida_flujo' | 'navegacion_fuera' | 'cierre_modal' | 'otro'

export type EstadoComprobanteAnalitica = 'enviado' | 'aceptado' | 'rechazado' | 'por_corregir' | 'anulado'

export type TipoComprobanteAnalitica = 'factura' | 'boleta' | 'nota_credito' | 'nota_debito' | 'otro'

export type FormaPagoAnalitica = 'contado' | 'credito'

export type TipoAyudaAnalitica = 'centro_ayuda' | 'recurso' | 'soporte' | 'tour' | 'otro'

export type OrigenAyudaAnalitica = 'header' | 'modulo' | 'tour' | 'panel' | 'otro'

export type AccionBorradorAnalitica = 'guardado' | 'reanudado'

export type OrigenProducto = 'emision_inline' | 'catalogo'

export type OrigenCliente = 'emision_inline' | 'clientes'

export type EntidadImportacion = 'productos' | 'clientes' | 'precios' | 'stock'

export type ResultadoImportacion = 'exito' | 'con_errores'

export type ErroresRangoImportacion = '0' | '1-5' | '6-20' | '21+'
